import events from './events';
// Constants
const SW_KEY = "sw_registered_time";
const SW_EXPIRE_DAYS = 30; // adjust as needed

// Register or cleanup service workers
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {

    const now = Date.now();
    const savedTime = localStorage.getItem(SW_KEY);

    // ✅ Step 1: Register the new service worker
    navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          console.log("Service Worker registered:", reg.scope);
        })
        .catch((err) => {
          console.error("Service Worker not registered:", err);
    });
   
  
    // ✅ Step 2: Unregister any old '/sw.js'
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        if (
          registration.active &&
          registration.active.scriptURL.includes("/sw.js")
        ) {
          registration.unregister().then(() => {
            console.log("Old /sw.js unregistered");
          });
        }
      });
    });

    // ✅ Step 3: Clear any old caches (optional, adjust filter)
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        if (cacheName.includes("old-sw") || cacheName.includes("sw.js")) {
          caches.delete(cacheName);
          console.log("Deleted old cache:", cacheName);
        }
      });
    });

    // ✅ Step 4: Handle expiration logic for new SW
    if (!savedTime) {
      // First time registration
      localStorage.setItem(SW_KEY, now);
    } else {
      const timeElapsed = now - parseInt(savedTime, 10);
      const expireTime = SW_EXPIRE_DAYS * 24 * 60 * 60 * 1000;

      if (timeElapsed > expireTime) {
        // Time exceeded - unregister and clear time
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => {
            registration.unregister();
          });
        });
        localStorage.removeItem(SW_KEY);
        console.log("Service Worker expired and unregistered");
      }
    }

  });
}


//User Register Function
window.oms_UserRegisterFn = events.UserRegisterFn;

new events.GetSettings().load();
new events.GetLanguage().load();
new events.GetFilters().load();
new events.GetOpeningHours().load();
new events.UserLogin().load();
new events.GetCategories().load();
new events.GetBaseCategories().load();
new events.GetProductList().load();
new events.GetCountryList().load();
new events.UserRegister().load();
new events.GetProduct().load();
new events.GetAdditionalCharges().load();
new events.GetValidateCart().load();
new events.GetCartOffers().load();
new events.UserProfile().load();
new events.GetCityList().load();
new events.GetShippingPrimaryPrice().load();
new events.GetShippingSecondaryPrice().load();
new events.CalculateOpeningHours().load();
new events.GetLoyaltyPoints().load();
new events.SaveOrderInfo().load();
new events.GetOrderInfo().load();
new events.GetUserData().load();
new events.GetCartProducts().load();
new events.UpdateCart().load();
new events.CalculateLoyaltyPoints().load();
new events.SubmitOrder().load();
new events.ChangeLocation().load();
new events.GetCurrentLocation().load();
new events.ProceedToPayment().load();
new events.UserProfileEdit().load();
new events.UserChangePassword().load();
new events.UserChangeProfileImage().load();
new events.UserLogout().load();
new events.GetOrderHistory().load();
new events.GetCheckoutStatus().load();
new events.UpdateCheckoutStatus().load();
new events.ValidateDiscountCode().load();
new events.GetDiscountCode().load();
new events.UpdateDiscountCode().load();
new events.UserForgotPassword().load();
new events.UserResetPassword().load();
new events.GetPaymentMethods().load();
new events.GetSpecificProducts().load();
new events.GetBestSellingProducts().load();
new events.GetOfferProducts().load();
new events.GetAddresses().load();
new events.GetAddress().load();
new events.SaveAddress().load();
new events.EditAddress().load();
new events.DeleteAddress().load();
new events.SetDefaultAddress().load();
new events.getFacertData().load();
new events.getFilterProduct().load();
new events.GetQuantityBasePriceModule().load();
new events.GetAbandonedCart().load();
new events.StoreCart().load();
new events.GetCategroy().load();
new events.GetCategroyByProduct().load();
new events.GetCategroyByCode().load();
new events.GetTemplateList().load();
new events.GetSocialProviders().load();
new events.SetSocialAuth().load();
new events.GetCmsPageContent().load();
new events.VerifyOtp().load();
new events.GetSocialUserVerificationData().load();
new events.UserRegisterBySocialVerification().load();
new events.UploadMediaReview().load();
new events.SubmitReview().load();
new events.EmailVerification().load();
new events.SaveContactFormData().load();
new events.OrderCancellationRequest().load();
new events.TrackOrderDetails().load();
new events.CheckOrderStatus().load();
new events.GetAllReviews().load();
new events.GetPendingReviews().load();
new events.DeleteReview().load();
new events.EditReview().load();
new events.GetProductReview().load();

new events.GetOfferCategories().load();
new events.GetFavoriteList().load();
new events.AddToFavorite().load();
new events.RemoveFavoriteProduct().load();
new events.ClearFavoriteList().load();
new events.VerifyRegisterEmail().load();
new events.ResendRegisterEmail().load();
